"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputBase = _interopRequireDefault(require("./input-base"));
var _characterCounter = _interopRequireDefault(require("./character-counter"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line react/display-name
const TextInputBase = _ref => {
  let {
    maxLength,
    onChange: propsOnChange,
    displayCharacterCount,
    characterCountReachedMessage,
    errors,
    children,
    ...props
  } = _ref;
  const [localValue, setLocalValue] = (0, _react.useState)('');
  const localOnChange = e => setLocalValue(e.target.value);
  const getCount = () => propsOnChange ? props.value.length : localValue.length;
  const isCharacterCountReached = () => displayCharacterCount && getCount(propsOnChange, props.value, localValue) === maxLength;

  // Parse maxLength strings into numbers
  maxLength && (maxLength = (0, _parseInt2.default)(maxLength, 10));

  // Add the textcount error
  const modifiedErrors = isCharacterCountReached() ? (0, _concat.default)(errors).call(errors, [characterCountReachedMessage]) : errors;
  return /*#__PURE__*/_react.default.createElement(_inputBase.default, (0, _extends2.default)({
    errors: modifiedErrors,
    maxLength: maxLength
  }, props), InputProps => {
    const TextInputProps = {
      ...InputProps,
      value: propsOnChange ? props.value : localValue,
      maxLength,
      onChange: propsOnChange ? propsOnChange : localOnChange
    };
    const count = getCount();
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children(TextInputProps), maxLength >= 0 ? /*#__PURE__*/_react.default.createElement(_characterCounter.default, {
      id: `${props.id}-character-count`,
      "aria-live": "polite",
      "aria-label": `${maxLength - count} characters remaining`,
      limit: maxLength,
      count: count,
      displayCharacterCount: displayCharacterCount
    }) : null);
  });
};
TextInputBase.propTypes = {
  ..._inputBase.default.propTypes,
  /**
   * A number or a string representation of a number indicating the max number of characters the
   * input can hold
   */
  maxLength: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * A boolean to indicate whether or not a character count should be displayed.
   * This prop will only render a character count display if a maxLength attr is also specified.
   */
  displayCharacterCount: _propTypes.default.bool,
  /**
   * The message to display when the maxLength is reached if displayCharacterCount is set to true.
   */
  characterCountReachedMessage: _propTypes.default.string
};
TextInputBase.defaultProps = {
  ..._inputBase.default.defaultProps,
  maxLength: undefined,
  displayCharacterCount: false,
  characterCountReachedMessage: 'You have reached the character limit.'
};
var _default = exports.default = TextInputBase;
TextInputBase.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextInputBase",
  "props": {
    "maxLength": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A number or a string representation of a number indicating the max number of characters the\ninput can hold",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "displayCharacterCount": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "A boolean to indicate whether or not a character count should be displayed.\nThis prop will only render a character count display if a maxLength attr is also specified.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "characterCountReachedMessage": {
      "defaultValue": {
        "value": "'You have reached the character limit.'",
        "computed": false
      },
      "description": "The message to display when the maxLength is reached if displayCharacterCount is set to true.",
      "type": {
        "name": "string"
      },
      "required": false
    }
  },
  "composes": ["./input-base"]
};